var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Footer"},[_vm._v(" © 2024 河南中昊供应链管理有限公司    "),_c('span',{staticClass:"beian",on:{"click":_vm.toPage}},[_vm._v("豫ICP备19037978号-1")])])
}
var staticRenderFns = []

export { render, staticRenderFns }